/**
 * Loading Spinner Component
 * 
 * Purpose: Reusable loading indicator
 */

import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
  }

  return (
    <Loader2
      className={`${sizeClasses[size]} animate-spin text-primary-600 ${className}`}
    />
  )
}

